import React from 'react'
import { withTranslation } from 'react-i18next'
import * as UIcons from '@iconscout/react-unicons'

const REPORT_TYPES = [
  { key: 'performance', icon: UIcons.UilImage },
  { key: 'campaign', icon: UIcons.UilMegaphone },
  { key: 'audience', icon: UIcons.UilUsersAlt },
  { key: 'location', icon: UIcons.UilMapMarker },
  { key: 'device', icon: UIcons.UilDesktop },
  { key: 'daily_summary', icon: UIcons.UilCalendarAlt },
  { key: 'customer', icon: UIcons.UilUserSquare }
]

export default withTranslation()(function ReportTypesSection({ t, onSelectType, onCreateCustom }) {
  return (
    <div className="bg-white rounded-2xl border border-border-lines p-4 mb-5">
      <div className="flex items-center justify-between gap-4 mb-4">
        <p className="text-base font-semibold text-dark-blue">{t('reports.types.title')}</p>

        <button
          type="button"
          onClick={onCreateCustom}
          className="flex items-center gap-1.5 border border-border-lines rounded-full h-9 px-4 text-sm font-medium text-dark-blue whitespace-nowrap"
        >
          <UIcons.UilPlus size={16} /> {t('reports.types.create_custom')}
        </button>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {
          REPORT_TYPES.map(({ key, icon: Icon }) => (
            <button
              key={key}
              type="button"
              onClick={() => onSelectType(key)}
              className="flex items-center gap-4 border border-border-lines rounded-xl p-4 text-left hover:bg-background"
            >
              <Icon size={28} className="text-primary shrink-0" />

              <div className="flex-1 min-w-0">
                <p className="text-base text-dark-blue truncate">{t(`reports.types.${key}.title`)}</p>
                <p className="text-sm text-secondary truncate">{t(`reports.types.${key}.subtitle`)}</p>
              </div>

              <UIcons.UilAngleRight size={20} className="text-secondary shrink-0" />
            </button>
          ))
        }
      </div>
    </div>
  )
})
